module.exports = __webpack_public_path__ + "img/noData.d4e40676.png";